<form [formGroup]="passwordUpdate" (ngSubmit)="onPasswordUpdate()" #passwordUpdateForm="ngForm">
  <div class="popup-close" mat-dialog-close>
    <svg-icon name="close"></svg-icon>
  </div>
  <h1 mat-dialog-title class="popup-title">Change password</h1>
  <div mat-dialog-content>
    <mat-form-field class="simplify-material-field d-flex flex-column" hintLabel="Required" appearance="fill">
      <mat-label>Current password</mat-label>
      <input type="password" matInput required formControlName="current" />
    </mat-form-field>

    <mat-form-field class="simplify-material-field d-flex flex-column" hintLabel="Required" appearance="fill">
      <mat-label>New password</mat-label>
      <input type="password" matInput required formControlName="newly" />
      <mat-hint align="end" *ngIf="newly.hasError('match')">Unmatched</mat-hint>
    </mat-form-field>

    <mat-form-field class="simplify-material-field d-flex flex-column" hintLabel="Required" appearance="fill">
      <mat-label>Confirm password</mat-label>
      <input type="password" matInput required formControlName="confirm" />
      <mat-hint align="end" *ngIf="confirm.hasError('match')">Unmatched</mat-hint>
    </mat-form-field>
  </div>
  <div class="row" *ngIf="isLoading$ | async">
    <app-loader></app-loader>
  </div>
  <h6 *ngIf="renderUpdateSuccessMsg$ | async" class="text-center">Password has been successfully updated</h6>
  <div mat-dialog-actions>
    <button *ngIf="renderUpdateBtn$ | async" class="btn btn-active" [disabled]="passwordUpdate.invalid">Update</button>
  </div>
</form>
